import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createUser } from '../store/userSlice';
import { useState } from 'react';
import { fetch } from '../store/driversSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { useModals } from '@mattjennings/react-modal-stack';
import ImagePickerModal from '../components/ImagePickerModal';


function CreateUser(props) {
    const { openModal } = useModals();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [ firstname, setFirstname ] = useState('');
    const [ phone, setPhone ] = useState('');
    const [ username, setUsername ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ passwordAgain, setPasswordAgain ] = useState('');
    const [ role, setRole ] = useState('driver');

    async function onSubmit() {
        const res = await unwrapResult(await dispatch(createUser({
            username,
            firstname,
            phone,
            email,
            password,
            role
        })));
        if(!res) return;
        
        const { id } = res;

        console.log("created user with id:", id);

        function callback() {
            dispatch(fetch({ id }));
            navigate('/platform/resources');
        }

        openModal(ImagePickerModal, { title: firstname, url: `/driver/${id}/photo`, callback });
    }




    return (
        <div className="row p32 center-main">
            <div className="column g32">
                <h1>Loo kasutaja</h1>

                <div className="line g32">

                    <div className="grow column g16">
                        <div className="column g4">
                            <b>Eesnimi</b>
                            <input type="text" autocomplete="off" value={firstname} onChange={(e) => setFirstname(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Telefon</b>
                            <input type="text" autocomplete="off" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Kasutajanimi</b>
                            <input type="text" autocomplete="off" value={username} onChange={(e) => setUsername(e.target.value)} />
                        </div>
                    </div>

                    <div className="grow column g16">
                        <div className="column g4">
                            <b>E-post</b>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Parool</b>
                            <input type="password" autoComplete='new-password' value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Parool uuesti</b>
                            <input type="password" autoComplete='new-password' value={passwordAgain} onChange={(e) => setPasswordAgain(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Konto tüüp</b>
                            <select value={role} onChange={(e) => setRole(e.target.value)}>
                                <option value="driver">Juht</option>
                                <option value="admin">Admin</option>
                            </select>
                        </div>

                    </div>
                </div>

                <button onClick={onSubmit}>Loo kasutaja</button>
            </div>
        </div>
    );
};

export default CreateUser;